import { Box, HStack, Text, Button, Icon } from "@chakra-ui/react";
import { FiAlertCircle, FiX, FiRefreshCw } from "react-icons/fi";
import { useLunaStore, useLunaError } from "state/luna";

interface LunaErrorBannerProps {
  onRetry?: () => void;
}

export const LunaErrorBanner = ({ onRetry }: LunaErrorBannerProps) => {
  const error = useLunaError();
  const clearError = useLunaStore((state) => state.clearError);

  if (!error) return null;

  return (
    <Box
      bg="error.50"
      borderBottom="1px solid"
      borderColor="error.200"
      px="lg"
      py="sm"
    >
      <HStack justify="space-between">
        <HStack spacing="sm">
          <Icon as={FiAlertCircle} color="error.500" />
          <Text fontSize="sm" color="error.700">
            {error}
          </Text>
        </HStack>
        <HStack spacing="sm">
          {onRetry && (
            <Button
              size="xs"
              variant="ghost"
              leftIcon={<FiRefreshCw />}
              onClick={onRetry}
              color="error.600"
            >
              Retry
            </Button>
          )}
          <Button
            size="xs"
            variant="ghost"
            onClick={clearError}
            color="error.600"
          >
            <FiX />
          </Button>
        </HStack>
      </HStack>
    </Box>
  );
};
